import { Music } from "lucide-react";

/**
 * BrandMark — Vivo logomark.
 * Gradient brass square with a dark Music glyph + the word "Vivo" in Sora italic.
 */
const BrandMark = ({ size = "md", showText = true, className = "" }) => {
  const sizes = {
    sm: { box: "w-8 h-8", icon: "w-4 h-4", text: "text-lg" },
    md: { box: "w-10 h-10", icon: "w-5 h-5", text: "text-2xl" },
    lg: { box: "w-14 h-14", icon: "w-7 h-7", text: "text-3xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-mark">
      <div
        className={`${s.box} rounded-lg flex items-center justify-center flex-shrink-0`}
        style={{ background: "linear-gradient(135deg, #E6B800 0%, #997A00 100%)" }}
      >
        <Music className={`${s.icon} text-[#0A0908]`} strokeWidth={2.25} />
      </div>
      {showText && (
        <span
          className={`${s.text} italic font-heading tracking-tight leading-none text-foreground`}
          style={{ fontWeight: 600 }}
        >
          Vivo
        </span>
      )}
    </div>
  );
};

export default BrandMark;
